import React, { FC } from 'react';
import stringUtils from '../../utils/string';
import { PreviewFieldProps } from './PreviewField';

type PickedKeys = 'value' | 'placeholder';
type PreviewFieldDefaultProps = Pick<PreviewFieldProps, PickedKeys> & {
	valueClasses: string;
	defaultPlaceholder: string;
	fullValueTooltip?: boolean;
};

export const PreviewFieldDefault: FC<React.PropsWithChildren<PreviewFieldDefaultProps>> = ({
	value,
	valueClasses,
	placeholder,
	defaultPlaceholder,
	fullValueTooltip,
}) => {
	const hasValue = !stringUtils.isNullOrEmpty(value);
	const dynamicProps = {};

	if (fullValueTooltip) {
		dynamicProps['title'] = value;
	}

	return (
		<div
			className={valueClasses}
			{...dynamicProps}
		>
			{hasValue && value}
			{!hasValue && (placeholder || defaultPlaceholder)}
		</div>
	);
};

export default PreviewFieldDefault;
